import React from "react";
import Preloader from "../assets/preloader.gif";

function Loader() {
  return (
    <div className="flex md:h-[var(--vh)] h-full md:my-0 my-10 max-h-full items-center justify-center">
      <img width={80} src={Preloader} alt="loader"></img>
    </div>
  );
}

export default Loader;
